export const ChevronDown = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7.115" viewBox="0 0 12 7.115" className={className}>
    <g id="Chevron_Down" data-name="Chevron Down" transform="translate(-5)">
      <path id="Path_36" data-name="Path 36" d="M5.213.322.322,5.213A1.108,1.108,0,0,0,1.889,6.78L6,2.686,10.1,6.793A1.112,1.112,0,0,0,12,6.009a1.1,1.1,0,0,0-.329-.784L6.78.322A1.114,1.114,0,0,0,5.213.322Z" transform="translate(17 7.115) rotate(180)" fill="#b5a371" />
    </g>
  </svg>
);
